export default __webpack_public_path__ + "static/media/zedgrande.1fde12a1.png";